module.exports = __webpack_public_path__ + "static/wordpress1-16604f267a2c145d0286939f6bf66a85.png";